(() => {
  'use strict';
  if (window.mgBfCategoryVideo) return;
  window.mgBfCategoryVideo = true;

  const mobile = window.matchMedia('(max-width: 680px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cards = new Map();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = cards.get(entry.target);
        if (!state) return;
        state.near = entry.isIntersecting;
        update(state);
      });
    }, { rootMargin: '160px 0px', threshold: 0 })
    : null;

  function update(state) {
    const { video, card } = state;
    const source = mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
    if (reduced.matches || !source) {
      video.pause();
      video.removeAttribute('src');
      card.classList.remove('is-video-playing');
      return;
    }
    if (!state.near || document.hidden) {
      video.pause();
      return;
    }
    if (state.failedSource === source) return;
    if (video.getAttribute('src') !== source) {
      card.classList.remove('is-video-playing');
      video.src = source;
      video.load();
    }
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    const attempt = video.play();
    if (attempt) attempt.catch(() => {
      if (video.paused) card.classList.remove('is-video-playing');
    });
  }

  function init(root = document) {
    root.querySelectorAll('.mg-bf-category-video').forEach(video => {
      const card = video.closest('.mg-bf-category');
      if (!card || cards.has(card)) return;
      const state = { card, video, near: !observer, failedSource: '' };
      cards.set(card, state);
      video.addEventListener('playing', () => card.classList.add('is-video-playing'));
      video.addEventListener('error', () => {
        state.failedSource = video.getAttribute('src') || '';
        card.classList.remove('is-video-playing');
      });
      if (observer) observer.observe(card);
      else update(state);
    });
  }

  function refresh() {
    cards.forEach(state => {
      if (!state.card.isConnected) {
        if (observer) observer.unobserve(state.card);
        state.video.pause();
        cards.delete(state.card);
      } else update(state);
    });
  }

  mobile.addEventListener('change', refresh);
  reduced.addEventListener('change', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
